module.exports = __webpack_public_path__ + "static/media/bg-cta-3.2a39afd1.svg";